import {
  type InputHTMLAttributes,
  type SelectHTMLAttributes,
  type TextareaHTMLAttributes,
  type ReactNode,
  forwardRef,
  useId
} from "react";

interface FieldProps {
  label?: string;
  help?: string;
  error?: string;
  required?: boolean;
  children: (id: string) => ReactNode;
}

export function Field({ label, help, error, required, children }: FieldProps) {
  const id = useId();
  const message = error ?? help;
  return (
    <div className={`sgs-field${error ? " sgs-field--error" : ""}`}>
      {label && (
        <label className="sgs-field__label" htmlFor={id}>
          {label}
          {required && (
            <span className="sgs-field__required" aria-hidden>
              {" "}*
            </span>
          )}
        </label>
      )}
      {children(id)}
      {message && (
        <span className={`sgs-field__help${error ? " sgs-field__help--error" : ""}`} role={error ? "alert" : undefined}>
          {message}
        </span>
      )}
    </div>
  );
}

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className = "", ...rest }, ref) {
    return <input ref={ref} className={`sgs-input ${className}`.trim()} {...rest} />;
  }
);

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Select({ className = "", children, ...rest }, ref) {
    return (
      <select ref={ref} className={`sgs-select ${className}`.trim()} {...rest}>
        {children}
      </select>
    );
  }
);

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function Textarea({ className = "", ...rest }, ref) {
    return <textarea ref={ref} className={`sgs-textarea ${className}`.trim()} {...rest} />;
  }
);
